import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { InvestmentSpecFormV2 } from './InvestmentSpecFormV2'

export function InvestmentSpecCommandV2(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.unitlink.useInvestmentSpecActions')({
    tenantId,
    ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="unitLink.InvestmentSpecCommandDataV2"
      title={translate('investmentSpecModalButton.title')}
      commandDataForm={InvestmentSpecFormV2}
      {...props}
      submit={submit}
    />
  )
}
